export default __webpack_public_path__ + "static/media/functionalities_es.5e31f3fb.png";